import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { VbPaymentChangePaymentStepFormGroup } from '../../../../../models/shared/forms/vb-payment-change-payment-step-form-group';
import * as moment from 'moment';

export function lumpSumPaymentChangeStartDateValidator(allowableChangeDateIsoString: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const group = formGroup as VbPaymentChangePaymentStepFormGroup;
    const monthControl = group.controls.lumpSumPaymentMonth;
    const yearControl = group.controls.lumpSumPaymentYear;

    if (group.controls.forgoRecurringPayments.value) {
      if (monthControl.hasError('paymentStartBeforeAllowableChangeDate')) {
        const errors = { ...monthControl.errors };
        delete errors.paymentStartBeforeAllowableChangeDate;
        monthControl.setErrors(Object.keys(errors).length ? errors : null);
      }
      return null;
    }

    const month = monthControl.value;
    const year = yearControl.value;

    // If either value is missing, skip validation
    if (month === null || year === null) {
      if (monthControl.hasError('paymentStartBeforeAllowableChangeDate')) {
        const errors = { ...monthControl.errors };
        delete errors.paymentStartBeforeAllowableChangeDate;
        monthControl.setErrors(Object.keys(errors).length ? errors : null);
      }
      return null;
    }

    const constructedDate = moment({ year, month: month - 1, day: 1 });
    const allowableChangeDate = moment(allowableChangeDateIsoString);

    if (constructedDate.isBefore(allowableChangeDate, 'month')) {
      monthControl.setErrors({
        ...monthControl.errors,
        paymentStartBeforeAllowableChangeDate: true
      });
      return { paymentStartBeforeAllowableChangeDate: true };
    } else {
      if (monthControl.hasError('paymentStartBeforeAllowableChangeDate')) {
        const errors = { ...monthControl.errors };
        delete errors.paymentStartBeforeAllowableChangeDate;
        monthControl.setErrors(Object.keys(errors).length ? errors : null);
      }
      return null;
    }
  };
}
